import {FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function validateMatchingPasswords(): ValidatorFn {
  return (form: FormGroup): ValidationErrors | null => {
    return form.get('newPassword').value === form.get('newPasswordRepeat').value ? null : {passwordsDoNotMatch: true};
  };
}
